import React from "react";
import {Card, OverlayTrigger, Tooltip} from "react-bootstrap";
import {formatMenge} from "./format.js";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

const KLICKBAR = {
    ueberfaellig: "dringlichkeit",
    sofort: "dringlichkeit",
    bald: "dringlichkeit",
    offen_gesamt: "status",
};

/**
 * Kennzahlen-Kacheln am Kopf der Bestellvorschläge (Auftrag AP9 Punkt 3):
 * überfällig, sofort, bald, offene Vorschläge gesamt, Dosen/Paletten
 * gesamt. Kacheln mit 0 verschwinden vollständig (Hausregel). Die drei
 * Dringlichkeits-Kacheln und "Offene gesamt" sind klickbare Filter -
 * erneutes Klicken hebt den Filter wieder auf.
 */
export default function VorschlaegeKacheln({kacheln, dringlichkeit, status, onSetDringlichkeit, onSetStatus}) {
    const sichtbare = (kacheln || []).filter((k) => Number(k.anzahl) > 0);

    if (sichtbare.length === 0) {
        return null;
    }

    const istAktiv = (k) => {
        if (KLICKBAR[k.schluessel] === "dringlichkeit") {
            return dringlichkeit === k.schluessel;
        }
        if (KLICKBAR[k.schluessel] === "status") {
            return status === "offen";
        }
        return false;
    };

    const klick = (k) => {
        if (KLICKBAR[k.schluessel] === "dringlichkeit") {
            onSetDringlichkeit(dringlichkeit === k.schluessel ? "" : k.schluessel);
        } else if (KLICKBAR[k.schluessel] === "status") {
            onSetStatus(status === "offen" ? "" : "offen");
        }
    };

    return (
        <div className="d-flex flex-wrap gap-2 mb-3">
            {sichtbare.map((k) => {
                const klickbar = Boolean(KLICKBAR[k.schluessel]);
                const aktiv = klickbar && istAktiv(k);
                const inhalt = (
                    <Card className={`shadow-sm h-100 ${aktiv ? "border-primary border-2" : ""}`} style={{minWidth: 190}}>
                        <Card.Body className="py-2 px-3">
                            <div className="small text-muted mb-1">{k.label}</div>
                            <div className="fw-semibold fs-5">
                                {formatMenge(k.anzahl)}
                                {k.zusatz !== undefined && <span className="fs-6 text-muted"> / {formatMenge(k.zusatz)} Pal.</span>}
                            </div>
                        </Card.Body>
                    </Card>
                );

                return (
                    <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} key={k.schluessel} placement="top" overlay={<Tooltip id={`cosmos-vorschlaege-kachel-${k.schluessel}`}>{k.hilfe}</Tooltip>}>
                        {klickbar ? (
                            <button type="button" onClick={() => klick(k)} className="btn p-0 border-0 bg-transparent text-start" aria-pressed={aktiv}>
                                {inhalt}
                            </button>
                        ) : (
                            <div>{inhalt}</div>
                        )}
                    </OverlayTrigger>
                );
            })}
        </div>
    );
}
